import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PaginationButton,
  PaginationContainer,
  PaginationInfo,
} from './Pagination.Styles';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const { t } = useTranslation();

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <PaginationContainer>
      <PaginationButton
        onClick={handlePreviousPage}
        disabled={currentPage <= 1}
      >
        ← {t('Previous Page')}
      </PaginationButton>

      <PaginationInfo>
        {t('Page')} {currentPage} {t('of')} {totalPages}
      </PaginationInfo>

      <PaginationButton
        onClick={handleNextPage}
        disabled={currentPage >= totalPages}
      >
        {t('Next Page')} →
      </PaginationButton>
    </PaginationContainer>
  );
};

export default Pagination;
